"use client"

import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import Link from "next/link"
import { handleSignUpClick } from "@/lib/tracking"

export function HeroSection() {
  return (
    <section
      className="relative flex min-h-[80vh] items-center justify-center overflow-hidden px-6 pb-24"
      style={{ paddingTop: 'calc(var(--banner-height, 0px) + 100px + 1.5rem)' }}
    >
      {/* Background glow */}
      <div
        className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-[500px] w-[800px] rounded-full opacity-15"
        style={{
          background:
            "radial-gradient(ellipse at center, #10B981 0%, transparent 70%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto flex max-w-3xl flex-col items-center text-center">
        <span className="mb-6 inline-block rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
          About Infinitcode AI
        </span>

        <h1 className="text-balance text-4xl font-bold leading-tight tracking-tight text-foreground md:text-6xl lg:text-7xl">
          Enabling Scalable{" "}
          <span className="text-primary">Engineering Excellence</span>
        </h1>

        <p className="mt-6 max-w-2xl text-pretty text-lg leading-relaxed text-muted-foreground md:text-xl">
          Infinitcode AI was created to address a growing challenge in modern
          software organizations: maintaining code quality, security, and
          architectural clarity as systems and teams scale.
        </p>

        <p className="mt-4 max-w-2xl text-pretty text-base leading-relaxed text-muted-foreground md:text-lg">
          As our parent company expanded, we experienced firsthand how increasing
          codebase complexity impacts review cycles, onboarding speed, and overall
          development velocity. Traditional review processes became insufficient
          for large, evolving systems.
        </p>

        <p className="mt-4 max-w-2xl text-pretty text-base font-semibold leading-relaxed text-foreground md:text-lg">
          Infinitcode AI was built to solve that problem at scale.
        </p>

        <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
          <Link href="https://app.infinitcode.ai/" target="_blank">
            <Button size="lg" className="gap-2 rounded-full px-8 text-base font-semibold" onClick={handleSignUpClick}>
              Get a free trial
              <ArrowRight className="size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
